<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.9558 7.56566L13.9418 10.6406C13.9418 10.6406 13.9601 5.619 13.9632 4.20685C13.9637 3.55132 13.4314 3.01895 12.7758 3.01951C12.1198 3.01951 11.5885 3.55076 11.5885 4.20685C11.5864 5.59701 11.5773 10.6406 11.5773 10.6406L11.5902 3.08724C11.5908 2.43171 11.0584 1.89934 10.4029 1.8999C9.74677 1.8999 9.21552 2.43116 9.21552 3.08724C9.21395 4.78283 9.206 10.6404 9.206 10.6404L9.21552 5.32625C9.21608 4.67073 8.68371 4.13835 8.02818 4.13891C7.37209 4.13891 6.84084 4.67016 6.84084 5.32625L6.82404 12.72L5.10305 10.9994C4.48447 10.3809 3.48242 10.3809 2.86384 10.9994C2.24526 11.618 2.24526 12.6201 2.86384 13.2387C4.73505 15.1099 7.16601 18.5666 10.9568 18.5666C14.7477 18.5666 16.3162 15.8383 16.317 13.2688L16.331 7.56622C16.331 6.91013 15.7998 6.37888 15.1437 6.37888C14.4876 6.37888 13.9552 6.91013 13.9558 7.56566Z"
      stroke="white" stroke-linejoin="round" />
  </svg>
</template>
<style scoped>
svg {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
}
</style>
